var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31006 5C2.31006 3.48122 3.54128 2.25 5.06006 2.25H19.0601C20.5788 2.25 21.8101 3.48122 21.8101 5V11.4697C21.8101 11.8839 21.4743 12.2197 21.0601 12.2197C20.6458 12.2197 20.3101 11.8839 20.3101 11.4697V5C20.3101 4.30964 19.7504 3.75 19.0601 3.75H5.06006C4.3697 3.75 3.81006 4.30964 3.81006 5V19C3.81006 19.6904 4.3697 20.25 5.06006 20.25H9.5C9.91421 20.25 10.25 20.5858 10.25 21C10.25 21.4142 9.91421 21.75 9.5 21.75H5.06006C3.54128 21.75 2.31006 20.5188 2.31006 19V5Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 17.47C6.25 17.0558 6.58579 16.72 7 16.72H9.5C9.91421 16.72 10.25 17.0558 10.25 17.47C10.25 17.8842 9.91421 18.22 9.5 18.22H7C6.58579 18.22 6.25 17.8842 6.25 17.47Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 6.96997C6.25 6.55576 6.58579 6.21997 7 6.21997H17C17.4142 6.21997 17.75 6.55576 17.75 6.96997C17.75 7.38418 17.4142 7.71997 17 7.71997H7C6.58579 7.71997 6.25 7.38418 6.25 6.96997Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 10.47C6.25 10.0558 6.58579 9.71997 7 9.71997H12C12.4142 9.71997 12.75 10.0558 12.75 10.47C12.75 10.8842 12.4142 11.22 12 11.22H7C6.58579 11.22 6.25 10.8842 6.25 10.47Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 13.97C6.25 13.5558 6.58579 13.22 7 13.22H9.5C9.91421 13.22 10.25 13.5558 10.25 13.97C10.25 14.3842 9.91421 14.72 9.5 14.72H7C6.58579 14.72 6.25 14.3842 6.25 13.97Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9092 14.2875C13.8239 14.2875 13.75 14.3606 13.75 14.4474V21.4946C13.75 21.5815 13.8239 21.6545 13.9092 21.6545H22.0915C22.1768 21.6545 22.2507 21.5815 22.2507 21.4946V15.8077C22.2507 15.7209 22.1768 15.6478 22.0915 15.6478H18.0049C17.4932 15.6478 17.0044 15.4101 16.6925 15.0051L16.691 15.0032L16.3049 14.4986M12.25 14.4474C12.25 13.5333 12.9943 12.7875 13.9092 12.7875H16.0866C16.8016 12.7875 17.2556 13.2731 17.4957 13.5864L17.8808 14.0898C17.9054 14.1214 17.9532 14.1478 18.0049 14.1478H22.0915C23.0064 14.1478 23.7507 14.8936 23.7507 15.8077V21.4946C23.7507 22.4087 23.0064 23.1545 22.0915 23.1545H13.9092C12.9943 23.1545 12.25 22.4087 12.25 21.4946V14.4474Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAssets);
export default __webpack_public_path__ + "static/media/fileAssets.f5d606c43eb078461e639bc54da5f638.svg";
export { ForwardRef as ReactComponent };